import { render, staticRenderFns } from "./ActionText.vue?vue&type=template&id=5d694b40&scoped=true"
import script from "./ActionText.vue?vue&type=script&lang=js"
export * from "./ActionText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d694b40",
  null
  
)

export default component.exports